
import Element from 'element-ui'
import { isLongitude, isLatitude, checkPwd } from './functions'

// 验证字段>0，Id，number类，select 中由change事件触发
const validateIntKey = (msg?: string) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        if (value > 0) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
const validateNullOrNumber = (msg?: string) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        if (value != "") {
            if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
                callback(new Error(msg))
            } else {
                callback()
            }
        } else {
            callback()
        }
    }
}
const validateArrayNotEmpty = (msg?: string) => {
    return (rule: any, value: string[], callback: (error?: Error) => void) => {
        console.log('validateArrayNotEmpty', value)
        if (value && value.length > 0) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
const validateDateRange2 = (msg?: string) => {
    return (rule: any, value: string[], callback: (error?: Error) => void) => {
        if (value && value.length == 2) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
// form: { [key: string]: string }, startDateField: string, endDateField: string
const validateDateRange = (form: { [key: string]: string }, startField: string, endField: string, msg: string) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        const start: string = form[startField]
        const end: string = form[endField]
        const startDate: Date = (new Date(start))
        const endDate: Date = (new Date(end))
        if (startDate < endDate) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
// URL
const validateURL = (rule: any, value: string | null, callback: (error?: Error) => void) => {
    if (!value) {
        return callback(rule.message);
    }
    if (!value || /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|www\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/.test(value)) {
        return callback()
    } else {
        return callback(new Error('格式不正确'))
    }
}
// 手机号
const validatePhone = (rule: any, value: string | null, callback: (error?: Error) => void) => {
    if (!value) {
        return callback(rule.message);
    }
    if (!value || /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(value)) {
        return callback()
    } else {
        return callback(new Error('手机格式不正确'))
    }
}
//验证整数
const validateInt = (rule: any, value: any | null, callback: (error?: Error) => void) => {
    if (!value && value != 0) {
        return callback(rule.message)
    }
    if (Number.isInteger(value)) {
        return callback()
    } else {
        return callback(new Error(rule.message))
    }
}
//验证浮点数
const validateFloat = (rule: any, value: any | null, callback: (error?: Error) => void) => {
    if (!value && value != 0) {
        return callback(rule.message)
    }
    if (/^\d+(\.\d+)?$/.test(value)) {
        return callback()
    } else {
        return callback(rule.message)
    }
}
// 固定电话 Telephone
const validateTel = (rule: any, value: string | null, callback: (error?: Error) => void) => {
    if (!value) {
        return callback(rule.message);
    }
    // 座机格式
    // var isTel = /^0?1[3|4|5|8][0-9]\d{8}$/
    var isTel = /^\d{3,4}-?\d{7,9}$/
    if (!value || isTel.test(value)) {
        return callback()
    } else {
        return callback(new Error('电话格式不正确'))
    }
}
const pwdMsg = "密码需在8~24位之间，至少包含数字、字母及特殊字符中的两种。"
const validatePwd = (rule: any, value: string | null, callback: (error?: Error) => void) => {
    if (!value) {
        return callback(new Error(pwdMsg))
    }
    // 密码格式
    if (checkPwd(value)) {
        return callback()
    } else {
        return callback(new Error(pwdMsg))
    }
}
// 字段比较，如：密码和确认密码
const validateCompare = (compareField: string, msg: string, form: { [key: string]: string }) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        if (form[compareField] === value) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
// 校验新密码是否和旧密码一样，一样的密码不让修改
const validateOldPwd = (compareField: string, msg: string, form: { [key: string]: string }) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        if (form[compareField] != value) {
            callback()
        } else {
            callback(new Error(msg))
        }
    }
}
/*验证不正确，@后面跟大写字母，验证不通过
const validateEmail = (rule: any, value: string | null, callback: (error?: Error) => void) => {
    if (!value) {
        return callback(rule.message);
    }
    if (!value || /^([0-9A-Za-z\-_\.]+)@([[0-9A-Za-z]+\.[A-Za-z]{2,3}(\.[A-Za-z]{2})?)$/.test(value)) {
        return callback()
    } else {
        return callback(new Error('电子邮箱格式不正确'))
    }
}
*/
//经纬度输入验证
const validateLngLat = (validKey: string) => {
    return (rule: any, value: any, callback: (error?: Error) => void) => {
        const isLng = validKey === 'lng'
        const d: any = value
        let msg: string = ''
        if (d > 0) {
            if (isLng && !isLongitude(d)) {
                msg = '经度不能大于180度,小数0到6位!'
            }
            if (!isLng && !isLatitude(d)) {
                msg = '纬度不能大于90度,小数0到6位!'
            }
        }
        else {
            msg = isLng ? '请输入经度' : '请输入纬度'
        }
        if (msg != '') {
            callback(new Error(msg))
        }
        else {
            callback()
        }
    }
}
const validateDegree = (rule: any, value: any, callback: (error?: Error) => void) => {
    if (rule.tag === 'Lng' && value > 180) {
        return callback(new Error('经度不能大于180度'))
    }
    if (rule.tag === 'Lat' && value > 90) {
        return callback(new Error('纬度不能大于90度'))
    }
    return callback()
}
const validateMinuteSecond = (rule: any, value: any, callback: (error?: Error) => void) => {
    if (value >= 60) {
        return callback(new Error('不能大于60'))
    }
    return callback()
}

// 多个表单一起验证，返回所有表单的验证结果
const validateForms = (forms: Element.Form[]) => {
    function validOne(formName: Element.Form) {
        const result = new Promise<void>((resolve, reject) => {
            formName.validate((valid: boolean, obj: any) => {
                if (valid) {
                    resolve() // 成功
                } else {
                    reject(obj) // 失败
                }
            })
        })
        return result
    }
    const results: any[] = [] // 用来接受返回结果的数组
    forms.forEach((f: Element.Form, i: number) => {
        results.push(validOne(f))
    })
    return results
}
const validateMsgs = (obj: any) => {
    var msgList: string[] = []
    var keys = Object.keys(obj)
    keys.forEach((k: any, i: number) => {
        if (obj[k]) {
            msgList.push(obj[k][0].message)
        }
    })
    return msgList
}
const getValidMsg = (obj: any) => {
    let msg: string = ''
    var keys = Object.keys(obj)
    keys.forEach((k: any, i: number) => {
        if (obj[k]) {
            msg += '<div>' + obj[k][0].message + '</div>'
        }
    })
    return msg
}

const showVaildMsg = (msgBox: any, obj: any) => {
    var msg = getValidMsg(obj)
    if (msg != '') {
        msgBox({
            dangerouslyUseHTMLString: true,
            message: msg,
            type: 'warning'
        })
    }
}
export {
    validateDegree,
    validateMinuteSecond,
    // validateMsgs,
    showVaildMsg,
    validateForms,
    validateIntKey,
    validateNullOrNumber,
    validateInt,
    validateFloat,
    validatePwd,
    validateTel,
    validatePhone,
    validateCompare,
    validateOldPwd,
    validateArrayNotEmpty,
    validateDateRange,
    validateDateRange2,
    // validateEmail,
    validateLngLat,
    validateURL
}
